import type { IDataAdapter } from '../../adapters/data/IDataAdapter';
import { cubaDayKey } from '../../core/time/cubaTime';
import { nativeOfficialPicksBag } from '../../core/lottery/officialDrawFormat';
import { normalizeManualDrawInput } from '../../core/rules/manualDrawPublish';

export type DrawTriple = [string, string, string];

export {
  normalizeManualDrawInput,
  normalizeOfficialPicksInput,
} from '../../core/rules/manualDrawPublish';
export type { NormalizedManualDraw } from '../../core/rules/manualDrawPublish';

export function isValidDrawTriple(vals: string[]): vals is DrawTriple {
  return vals.length === 3 && normalizeManualDrawInput(vals[0], vals[1], vals[2]) != null;
}

export async function publishDrawResults(
  adapter: Pick<IDataAdapter, 'publishResult'>,
  vals: DrawTriple | string[],
  options: {
    houseId?: string;
    source?: string;
    window?: 'day' | 'night';
    /** Cuba / business day for the turn (defaults to today). */
    dayKey?: string;
    publishedBy?: string;
    publishedByName?: string;
    feed?: 'auto' | 'manual';
  } = {},
) {
  const normalized = normalizeManualDrawInput(
    String(vals[0] ?? ''),
    String(vals[1] ?? ''),
    String(vals[2] ?? ''),
  );
  if (!normalized) {
    throw new Error('invalid-draw');
  }
  const {
    source = 'florida',
    window = 'day',
    publishedBy,
    publishedByName,
    feed = 'manual',
    dayKey = cubaDayKey(new Date()),
  } = options;
  const picksBag = nativeOfficialPicksBag(source, normalized.pick3, normalized.pick4);
  return adapter.publishResult({
    houseId: options.houseId ?? '',
    first: normalized.first,
    second: normalized.second,
    third: normalized.third,
    source,
    window,
    dayKey,
    feed,
    publishedBy,
    publishedByName,
    picks: Object.keys(picksBag).length > 0 ? picksBag : undefined,
  });
}
